<div class="wrapper-md">
    <app-breadcrumbs [items]="[
                     { url: '/thesis-reports', text: 'thesisReport_listTitle' },
                     {
                        url: '/thesis-reports/' + (isNew ? 'add' : report?.Id),
                        text: isNew ? 'thesisReport_newTitle' : 'thesisReport_editTitle'
                     }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{(isNew ? 'thesisReport_newTitle' : 'thesisReport_editTitle') | translate}}
        </h1>
    </header>

    <form #form="ngForm" class="was-validated">
        <div class="row">
            <div class="form-field required col-md-8">
                <label class="form-label">{{'thesisReport_lblDoctor' | translate}}</label>
                <app-select [(ngModel)]="doctor"
                            [options]="doctors"
                            [displayFn]="doctorDisplayFn"
                            [required]="true"
                            [filter]="doctorFilterFn"
                            (selectionChange)="onDoctorChange()"
                            name="doctor">
                </app-select>
            </div>
        </div>

        <ng-container *ngIf="doctor">
            <app-alert level="info">
                <div><label>{{'thesisReport_lblFirstName' | translate}}</label> {{doctor.FirstName}}</div>
                <div><label>{{'thesisReport_lblLastName' | translate}}</label> {{doctor.LastName}}</div>
                <div><label>{{'thesisReport_lblCertificateNumber' | translate}}</label> {{doctor.CertificateNumber}}</div>
                <div><label>{{'thesisReport_lblStudyProgram' | translate}}</label> [{{doctor.StudyProgramCode}}] {{doctor.StudyProgramName}}</div>
                <div><label>{{'thesisReport_lblSupervisor' | translate}}</label> {{getSupervisorDisplay(doctor)}}</div>
                <div *ngIf="doctor.PureProfileUrl" class="mt-1">
                    <a href="{{doctor.PureProfileUrl}}" target="_blank">{{'thesisReport_lblPureProfileLink' | translate}}</a>
                </div>
            </app-alert>

            <div class="form-field required" *ngIf="isAdmin">
                <label class="form-label">{{'thesisReport_lblPreparer' | translate}}</label>

                <div *ngFor="let n of preparers" class="mb-1">
                    <app-radio [(ngModel)]="preparer"
                               [value]="n"
                               name="preparer-{{n.id}}">
                        {{n.name}}
                    </app-radio>
                </div>
            </div>

            <div class="form-field">
                <label class="form-label">
                    {{'thesisReport_lblProgress' | translate}}
                    <app-help [text]="'thesisReport_hintProgress' | translate"></app-help>
                </label>
                <textarea class="form-control" [(ngModel)]="progress" name="progress" rows="5" #progressInput="ngModel"
                          [pattern]="getLengthValidationPattern(progress, 50, 4000, true)"></textarea>
                <div class="feedback" *ngIf="progressInput.valid">{{(progress || '').length}}/4000</div>
                <div class="invalid-feedback" *ngIf="progressInput.invalid">
                    {{'fieldError_lengthMinMax' | translate | formatString:[50, 4000]}}
                </div>
            </div>


            <div class="form-field">
                <label class="form-label">
                    {{'thesisReport_lblResults' | translate}}
                </label>
                <textarea class="form-control" [(ngModel)]="results" name="results" rows="5" #resultsInput="ngModel"
                          [pattern]="getLengthValidationPattern(results, 50, 4000, true)"></textarea>
                <div class="feedback" *ngIf="resultsInput.valid">{{(results || '').length}}/4000</div>
                <div class="invalid-feedback" *ngIf="resultsInput.invalid">
                    {{'fieldError_lengthMinMax' | translate | formatString:[50, 4000]}}
                </div>
            </div>

            <div class="form-field">
                <label class="form-label">
                    {{'thesisReport_lblActivity' | translate}}
                    <app-help [text]="'thesisReport_hintActivity' | translate"></app-help>
                </label>

                <div class="mb-1">
                    <app-checkbox [(ngModel)]="hasScientificActivity" name="hasScientificActivity">
                        {{'thesisReport_lblHasScientificActivity' | translate}}
                    </app-checkbox>
                </div>

                <div class="mt-1">
                    <app-checkbox [(ngModel)]="hasTeachingActivity" name="hasTeachingActivity">
                        {{'thesisReport_lblHasTeachingActivity' | translate}}
                    </app-checkbox>
                </div>
            </div>

            <div class="row">
                <div class="form-field col-md-4">
                    <label class="form-label">
                        {{'thesisReport_lblCooperationGrade' | translate}}
                        <app-help [text]="'thesisReport_hintCooperationGrade' | translate"></app-help>
                    </label>
                    <app-select [(ngModel)]="cooperationGradeId"
                                [options]="grades"
                                [valueProperty]="'Id'"
                                [displayProperty]="'Value'"
                                name="cooperationGradeId">
                    </app-select>
                </div>
            </div>

            <div class="form-field">
                <label class="form-label">
                    {{'thesisReport_lblAttachments' | translate}}
                    <app-help [text]="'thesisReport_hintAttachments' | translate"></app-help>
                </label>
                <div *ngFor="let a of attachments; let i = index" class="d-flex mb-2">
                    <div class="flex-grow-1">
                        <app-file [(ngModel)]="a.file"
                                  [accept]="attachmentExtensions"
                                  [maxSize]="attachmentMaxSize"
                                  name="attachment{{i}}"
                                  [immediate]="!a.id"
                                  (fileChange)="onFileChange($event, a)"
                                  #attachmentInput="ngModel"></app-file>
                        <div class="invalid-feedback" *ngIf="checkDuplicateFileName(a)">{{'thesisReport_lblAttachments' | translate}}</div>
                    </div>

                    <button class="btn btn-outline btn-icon align-self-end ms-3" *ngIf="a.id"
                            (click)="downloadAttachment(a)" [ngbTooltip]="'download' | translate">
                        <i class="fi fi-rs-download"></i>
                    </button>
                </div>

                <div>
                    <button class="btn btn-outline" type="button" (click)="addAttachment()"
                            [disabled]="attachments.length >= attachmentLimit || (attachments.length > 0 && !attachments[attachments.length - 1].file)">
                        <i class="fi fi-rs-plus"></i>
                        {{'thesisReport_btnAddFile' | translate}}
                    </button>
                </div>
            </div>
        </ng-container>

        <div class="form-actions">
            <span class="form-actions-group">
                <button class="btn btn-outline-primary" type="button" (click)="submit()" *ngIf="doctor">
                    <i class="fi fi-rs-paper-plane"></i>
                    {{'thesisReport_btnSubmit' | translate}}
                </button>
            </span>

            <span class="form-actions-group">
                <button class="btn btn-outline" type="button" [routerLink]="['/thesis-reports'] | localize">
                    {{'thesisReport_btnClose' | translate}}
                </button>

                <button class="btn btn-primary" type="button" (click)="save()" *ngIf="doctor">
                    {{'thesisReport_btnSave' | translate}}
                </button>
            </span>
        </div>
    </form>
</div>
